<!-- @format -->

<template>
  <div class="row">
    <sui-modal v-model="showModal">
      <sui-modal-header>Add Platform</sui-modal-header>
      <sui-modal-content image>
        <sui-modal-description>
          <sui-header>Platform</sui-header>
          <div class="ui form">
            <div class="field">
              <label>Platform Name</label>
              <input type="text" placeholder="Subject" />
            </div>
            <div class="field">
              <label>Message</label>
              <textarea rows="2"></textarea>
            </div>
          </div>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive>Add</sui-button>|
        <sui-button @click.native="showModal = false">Cancel</sui-button>
      </sui-modal-actions>
    </sui-modal>

    <div class="twelve wide column">
      <div class="ui attached segment">
        <h3>Advisory Fee</h3>
        <table class="ui table" v-if="advisoryFees.length > 1">
          <thead>
            <tr>
              <th>Description</th>
              <th>Lower Bracket</th>
              <th>Upper Bracket</th>
              <th>Fee</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="advfee in advisoryFees" :key="advfee.index">
              <td style="width: 450px">
                Between {{ advfee.lower | numeralFormat("0.00a") }} and
                {{ advfee.upper | numeralFormat("0.00a") }} an annual fee of
                {{ advfee.rate | numeralFormat("0.00") }}%
              </td>
              <td>
                <div class="ui labeled input">
                  <div class="ui label">R</div>
                  <vue-numeric
                    separator=","
                    v-on:focus="showSaveButton = true"
                    v-model="advfee.lower"
                    :min="0"
                  ></vue-numeric>
                </div>
              </td>
              <td>
                <div class="ui labeled input">
                  <div class="ui label">R</div>
                  <vue-numeric
                    class="ui input"
                    v-on:focus="showSaveButton = true"
                    separator=","
                    v-model="advfee.upper"
                    :min="0"
                  ></vue-numeric>
                </div>
              </td>
              <td>
                <div class="ui labeled input">
                  <div class="ui label">%</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    v-model="advfee.rate"
                    :min="0"
                    :step="0.05"
                    :precision="5"
                  ></vue-numeric>
                </div>
              </td>
              <td>
                <sui-button
                  floated="left"
                  size="small"
                  basic
                  labeled
                  v-on:click="removeAdvisoryFee(advfee.index)"
                >
                  <sui-icon name="minus" />Remove
                </sui-button>
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td colspan="5">
                <sui-button
                  floated="left"
                  labeled
                  v-on:click="
                    addAdvisoryFee(
                      advisoryFees.length == 0
                        ? 1
                        : advisoryFees[advisoryFees.length - 1].index + 1,
                      advisoryFees.length == 0
                        ? 0
                        : advisoryFees[advisoryFees.length - 1].upper + 1,
                      advisoryFees.length == 0
                        ? 99999999999
                        : advisoryFees[advisoryFees.length - 1].upper +
                            (advisoryFees[advisoryFees.length - 1].upper -
                              advisoryFees[advisoryFees.length - 1].lower),
                      0
                    )
                  "
                >
                  <sui-icon name="percent" />Add new fee bracket
                </sui-button>
              </td>
            </tr>
          </tfoot>
        </table>
        <table class="ui table" v-if="advisoryFees.length == 1">
          <tbody>
            <tr v-for="advfee in advisoryFees" :key="advfee.index">
              <td style="width: 450px">
                An annual fee of {{ advfee.rate | numeralFormat("0.00") }}%
              </td>

              <td>
                <div class="ui labeled input">
                  <div class="ui label">%</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    v-model="advfee.rate"
                    :min="0"
                    :step="0.05"
                    :precision="5"
                  ></vue-numeric>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr v-if="false">
              <td colspan="2">
                <sui-button
                  floated="left"
                  labeled
                  v-on:click="
                    addAdvisoryFee(
                      advisoryFees.length == 0
                        ? 1
                        : advisoryFees[advisoryFees.length - 1].index + 1,
                      advisoryFees.length == 0
                        ? 0
                        : advisoryFees[advisoryFees.length - 1].upper + 1,
                      advisoryFees.length == 0
                        ? 99999999999
                        : advisoryFees[advisoryFees.length - 1].upper +
                            (advisoryFees[advisoryFees.length - 1].upper -
                              advisoryFees[advisoryFees.length - 1].lower),
                      0
                    )
                  "
                  >Change to Sliding Scale</sui-button
                >
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="ui attached message">
        <div class="ui toggle checkbox">
          <input type="checkbox" name="public" v-model="showAdvisoryFees" />
          <label
            ><strong>Show</strong> Advisory Fees in Projection Analysis
          </label>
        </div>
        <br />
        <small v-if="!showAdvisoryFees"
          >Advisory fees are hidden in the projections screen. The default fee
          is used.</small
        >
        <small v-if="showAdvisoryFees"
          >Advisory fees are shown & editable in the projections screen</small
        >
      </div>

      <div class="ui segment">
        <h3>Platform Fees</h3>
        <table v-if="false" class="ui table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Lower Bracket</th>
              <th>Upper Bracket</th>
              <th>Fee</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="advfee in platformFees" :key="advfee.index">
              <td style="width: 450px">
                Between {{ advfee.lower | numeralFormat("0.00a") }} and
                {{ advfee.upper | numeralFormat("0.00a") }} an annual fee of
                {{ advfee.rate | numeralFormat("0.00") }}%
              </td>
              <td style="width: 200px">
                <div class="ui labeled input">
                  <div class="ui label">R</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    separator=","
                    v-model="advfee.lower"
                    :min="0"
                  ></vue-numeric>
                </div>
              </td>
              <td style="width: 200px">
                <div class="ui labeled input">
                  <div class="ui label">R</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    class="ui input"
                    separator=","
                    v-model="advfee.upper"
                    :min="0"
                  ></vue-numeric>
                </div>
              </td>
              <td>
                <div class="ui labeled input">
                  <div class="ui label">%</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    v-model="advfee.rate"
                    :min="0"
                    :step="0.05"
                    :precision="5"
                  ></vue-numeric>
                </div>
              </td>
              <td>
                <sui-button
                  floated="left"
                  size="small"
                  basic
                  blue
                  labeled
                  v-on:click="removePlatformFee(advfee.index)"
                >
                  <sui-icon name="minus" />Remove
                </sui-button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4">
                <sui-button
                  floated="left"
                  labeled
                  v-on:click="
                    addPlatformFee(
                      platformFees.length == 0
                        ? 1
                        : platformFees[platformFees.length - 1].index + 1,
                      platformFees.length == 0
                        ? 0
                        : platformFees[platformFees.length - 1].upper + 1,
                      platformFees.length == 0
                        ? 99999999999
                        : platformFees[platformFees.length - 1].upper +
                            (platformFees[platformFees.length - 1].upper -
                              platformFees[platformFees.length - 1].lower),
                      0
                    )
                  "
                >
                  <sui-icon name="percent" />Add new fee bracket
                </sui-button>
              </td>
            </tr>
          </tfoot>
        </table>
        <table class="ui table">
          <thead>
            <tr>
              <th>Description</th>

              <th>Fee</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="advfee in platformFees" :key="advfee.index">
              <td style="width: 450px">
                An annual fee of {{ advfee.rate | numeralFormat("0.00") }}%
              </td>

              <td>
                <div class="ui labeled input">
                  <div class="ui label">%</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    v-model="advfee.rate"
                    :min="0"
                    :step="0.05"
                    :precision="5"
                  ></vue-numeric>
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ui segment" v-if="showSaveButton">
        <div class="ui large green button" @click="saveFees">Save</div>
        |
        <div class="ui large grey button" @click="initialLoad">Cancel</div>
      </div>
      <div class="ui segment message" v-if="message != ''">{{ message }}</div>
    </div>
  </div>
</template>

<script>
import {
  getPartnerFees,
  savePartnerFees,
  getPartnerSettings,
  updatePartnerDefaultSettings,
} from "@/gateway";

import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "FeeTable",
  props: {
    msg: String,
  },
  data() {
    return {
      message: "",
      showAdvisoryFees: false,
      showSaveButton: false,
      showModal: false,
      // fees

      avisoryFeeId: 0,
      advisoryFees: [
        {
          index: 0,
          lower: 0,
          upper: 99999999999,
          rate: 0,
        },
      ],
      platformFeeId: 0,
      platformFees: [
        {
          index: 0,
          lower: 0,
          upper: 99999999999,
          rate: 0,
        },
      ],
    };
  },
  watch: {
    showAdvisoryFees(newval) {
      this.showSaveButton = true;
    },
  },
  computed: {
    ...mapState,
  },
  methods: {
    async removePlatformFee(indx) {
      let tempFees = this.platformFees;
      let newTempFees = [];
      this.platformFees = [];
      tempFees.forEach(function(d) {
        if (d.index != indx) newTempFees.push(d);
      });
      this.platformFees = newTempFees;
      this.showSaveButton = true;
    },
    async removeAdvisoryFee(indx) {
      let tempFees = this.advisoryFees;
      let newTempFees = [];
      this.advisoryFees = [];
      tempFees.forEach(function(d) {
        if (d.index != indx) newTempFees.push(d);
      });
      this.advisoryFees = newTempFees;
      this.showSaveButton = true;
    },

    async addPlatformFee(indx, lower, upper, rate) {
      this.platformFees.push({
        index: indx,
        lower,
        upper,
        rate,
      });

      this.showSaveButton = true;
    },
    async addAdvisoryFee(indx, lower, upper, rate) {
      this.advisoryFees.push({
        index: indx,
        lower,
        upper,
        rate,
      });
      this.showSaveButton = true;
    },
    async saveFees() {
      // platform fees
      var response = await savePartnerFees({
        partnerId: this.$store.state.partnerId,
        id: this.platformFeeId,
        feeBrackets: this.platformFees,
      });
      if (response) {
        // save advisory Fees
        var response2 = await savePartnerFees({
          partnerId: this.$store.state.partnerId,
          id: this.advisoryFeeId,
          feeBrackets: this.advisoryFees,
        });
        if (response2) {
          var response3 = await updatePartnerDefaultSettings({
            showAdvisoryFees: this.showAdvisoryFees,
          });
          if (response3) {
            this.showSaveButton = false;
            this.message = "Success";
            this.initialLoad();
          }
        }
      }
    },
    async getFees(feeName) {
      var response = await getPartnerFees({
        feeName,
        partnerId: this.$store.state.partnerId,
      });

      let newFees = [];
      let ind = 1;
      response.result[0].bracket.forEach(function(item) {
        newFees.push({
          index: ind,
          lower: item.lower,
          upper: item.upper,
          rate: item.rate,
        });
        ind++;
      });
      if (feeName == "Platform") {
        this.platformFees = newFees;
        this.platformFeeId = response.result[0].id;
      }
      if (feeName == "Advisory") {
        this.advisoryFees = newFees;
        this.advisoryFeeId = response.result[0].id;
      }
    },
    async initialLoad() {
      const response = await getPartnerSettings();
      if (response) {
        this.showAdvisoryFees =
          response.partnerDefaultSettings.showAdvisoryFees;
      }

      await this.getFees("Platform");
      await this.getFees("Advisory");
      this.showSaveButton = false;
    },
  },
  async mounted() {
    this.initialLoad();
  },
};
</script>
